/**
 * Pick the active access key with the latest (furthest) expiration.
 * Permanent keys (no expires_at) rank above timed keys.
 */
export function pickInstallerAccessKey(accessKeys) {
  const active = (accessKeys || []).filter((ak) => !ak.expired);
  if (!active.length) return null;

  const sorted = [...active].sort((a, b) => {
    if (!a.expires_at && !b.expires_at) return 0;
    if (!a.expires_at) return -1;
    if (!b.expires_at) return 1;
    return new Date(b.expires_at) - new Date(a.expires_at);
  });

  return sorted[0].key;
}
